module.exports = __webpack_public_path__ + "static/media/34-7.0e3d9751.mp3";